// src/store/product/productActions.js

import { ADD_PRODUCT } from "./productActionsTypes";
import axios from "axios";

export function addProduct(product) {
  return {
    type: ADD_PRODUCT,
    payload: product,
  };
}

export function getProduct(productId) {
  return (dispatch) => {
    return axios
      .get(`https://catalog.tstmetal.site/products?product_id=${productId}`)
      .then((res) => {
        // API возвращает [{…}], распаковываем массив
        const raw = res.data.product || res.data;
        const product =
          Array.isArray(raw) && raw.length > 0 ? raw[0] : raw;
        dispatch(addProduct(product));
      })
      .catch((err) => console.error(err));
  };
}
